import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const CoursService = {
  // Récupérer tous les cours
  async getAllCours() {
    try {
      const result = await axios.get(`${apiUrl}/cours`);
      return result.data;
    } catch (error) {
      console.error("Erreur dans getAllCours:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la récupération des cours",
        data: []
      };
    }
  },

  // Récupérer un cours par ID
  async getCoursById(id) {
    try {
      const result = await axios.get(`${apiUrl}/cours/${id}`);
      return result.data;
    } catch (error) {
      console.error(`Erreur dans getCoursById(${id}):`, error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la récupération du cours",
        data: null
      };
    }
  },

  // Créer un cours
  async createCours(data) {
    try {
      const result = await axios.post(`${apiUrl}/cours`, data, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      return result.data;
    } catch (error) {
      console.error("Erreur dans createCours:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la création du cours",
        data: null
      };
    }
  },

  // Mettre à jour un cours
  async updateCours(id, data) {
    try {
      
      const result = await axios.post(`${apiUrl}/cours/update/${id}`, data, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      return result.data;
    } catch (error) {
      console.error(`Erreur dans updateCours(${id}):`, error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la mise à jour du cours",
        data: null
      };
    }
  },

  // Supprimer un cours
  async deleteCours(id) {
    try {
      const result = await axios.delete(`${apiUrl}/cours/${id}`);
      return result.data;
    } catch (error) {
      console.error(`Erreur dans deleteCours(${id}):`, error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la suppression du cours",
        data: null
      };
    }
  },

  // Récupérer les questions QCM d'un cours
  async getQuestionsByCourse(courseId) {
    try {
      const result = await axios.get(`${apiUrl}/cours/questions/${courseId}`);
      return result.data;
    } catch (error) {
      console.error(`Erreur dans getQuestionsByCourse(${courseId}):`, error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la récupération des questions",
        data: []
      };
    }
  },

  // Créer une question QCM
  async createQuestion(data) {
    try {
      const result = await axios.post(`${apiUrl}/cours/question`, data);
      return result.data;
    } catch (error) {
      console.error("Erreur dans createQuestion:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la création de la question",
        data: null
      };
    }
  },

  // Mettre à jour une question
  async updateQuestion(id, data) {
    try {
      const result = await axios.put(`${apiUrl}/cours/question/${id}`, data);
      return result.data;
    } catch (error) {
      console.error(`Erreur dans updateQuestion(${id}):`, error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la mise à jour de la question",
        data: null
      };
    }
  },

  // Supprimer une question
  async deleteQuestion(id) {
    try {
      const result = await axios.delete(`${apiUrl}/cours/question/${id}`);
      return result.data;
    } catch (error) {
      console.error(`Erreur dans deleteQuestion(${id}):`, error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la suppression de la question",
        data: null
      };
    }
  },

   //Ajout historique
  async createHistory(data) {
    try {
      const result = await axios.post(`${apiUrl}/cours/recordhistory`, data);
      return result.data;
    } catch (error) {
      console.error("Erreur dans createQuestion:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la création de la question",
        data: null
      };
    }
  },

};

export default CoursService;